import _ from 'lodash';
import { selectSessions } from '../../state/chat/chatSlice';
import store from '../../state/store';

const arraysEqual = (_arr1, _arr2) => {
  if (_arr1.length !== _arr2.length) {
    return false;
  }

  const arr1 = _.sortBy(_arr1, 'id');
  const arr2 = _.sortBy(_arr2, 'id');

  let i = 0;
  while (i < arr1.length) {
    if ((arr1[i].id !== arr2[i].id)) {
      return false;
    }
    i += 1;
  }

  return true;
};

// will take in a list of contacts and try to determine what session it matches
// RIGHT NOW THIS IS ONLY FOR CHAT, SMS IS VIA A DIFFERENT WAY
const findSessionFromContactArr = (contactArr) => {
  let sessionReturn = false;

  // try to find the session via the list of contacts
  const sessions = selectSessions(store.getState());

  sessions.forEach((session) => {
    if (session.contactArr) {
      if (arraysEqual(session.contactArr, contactArr)
        && session?.smsani === '') {
        sessionReturn = session;
      }
    }
  });

  if (!sessionReturn) {
    // should return a new object for the session
  }

  return sessionReturn;
};

export default findSessionFromContactArr;
